import { createAction, props } from "@ngrx/store";
import { ServiceErrorWithList } from '../../create-request/models/shared/ServiceError';
import { DraftListAttributes, DraftResponse } from "../Models/Drafts/DraftResponse";
import { CustomRuleGetResponseData } from "../Models/CreateCustomRule/CreateCustomRule";

export const hasEmptyResponse = createAction(
    '[Init Release Table] Empty response for table'
)

export const printClicked = createAction(
    '[Init Release Table] User Requested Printout'
);

export const getInitReleaseList = createAction(
  '[Init Release] Call to get the list of Init release drafts'
);

export const getInitReleaseListSuccessful = createAction(
  '[Init Release] Get the list of Init release drafts',
  props<DraftResponse>()
);

export const saveCreateRuleValues = createAction(
  '[Init Release Create Custom Rule] Save Form Group Values',
  props<{ createCustomRuleSection: any }>()
);

export const getInitReleaseListFailed = createAction(
  '[Init Release] Fails to get the Init release drafts',
  props<ServiceErrorWithList>()
);

export const callInitReleaseByDraftId = createAction(
  '[Init Release] Call Statusview initRelease endpoint',
  props<{draftId: string, isSloa: boolean}>()
);

export const callCreateCustomRulesPost = createAction(
  '[Init Release Custom Rules] Call Custom Rules To Save Rule To Database',
);

export const callCustomRulesPostSuccessful = createAction(
  '[Init Release Custom Rules] Call Custom Rules To Save Rule To Database Successful',
);

export const callCustomRulesPostFailed = createAction(
  '[Init Release Custom Rules] Call Custom Rules To Save Rule To Database Failed',
);

export const callCreateCustomRulesGet = createAction(
  '[Init Release Custom Rules] Call Custom Rules To Get All Firm Rules',
);

export const callCustomRulesGetSuccessful = createAction(
  '[Init Release Custom Rules] Call Custom Rules To Get Rules From Database Successful',
  props<{ response: CustomRuleGetResponseData[] }>()
);

export const callCustomRulesGetFailed = createAction(
  '[Init Release Custom Rules] Call Custom Rules To Get Rules From Database Failed',
);

export const callCustomRulesDeleteByRuleId = createAction(
  '[Init Release Custom Rules] Call Custom Rules Delete Endpoint',
  props<{ruleId: string}>()
);

export const callCustomRulesDeleteSuccessful = createAction(
  '[Init Release Custom Rules] Call Custom Rules Delete Endpoint Successful',
);

export const callCustomRulesDeleteFailed = createAction(
  '[Init Release Custom Rules] Call Custom Rules Delete Endpoint Failed',
);

export const initReleaseByDraftIdSuccessful = createAction(
  '[Init Release] Call to Statusview initRelease endpoint successful',
  props<{ response: DraftListAttributes, isSloa: boolean, isNraAccount: boolean }>()
);

export const initReleaseByDraftIdFailed = createAction(
  '[Init Release] Call to Statusview initRelease endpoint failed',
  props<ServiceErrorWithList>()
);

export const deleteInitiatedDraft = createAction(
  '[Init Release] Delete Initiated Draft',
  props<{ draftId: string }>()
)

export const deleteInitiatedDraftSuccessful = createAction(
  '[Init Release] Delete Initiated Draft successful'
)

export const deleteInitiatedDraftFailed = createAction(
  '[Init Release] Delete Initiated Draft failed'
)

export const refresh = createAction(
  '[Init Release] Refresh Overview Data',
  props<{ accountId: string }>()
);

export const backButtonClicked = createAction('[Init Release] Back button clicked on review page');
